import React, { useState } from 'react';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Select from "react-select";

import CheckBox from '../../../../components/UI/Checkbox/CheckBox';
import { SelectedTickets } from '../../../OpenSell/SelectedTickets';
import { getPrice, getTotalFee } from "../../../../helpers/ticketPriceHelper.ts";

import { getCurrentLanguageTexts } from '../../../../constants/seasonPassPersonalInfoLangs';
import { getSeatLabel, MembershipToSeasonPassTicket, NfcToTicket } from '../../../../helpers/ticketHelper.ts';
import TermsAndConditionsModal from "../../TermsAndConditionsModal/TermsAndConditionsModal.js";
import { IconButton } from '../../../../components/UI/IconButton/IconButton.js';

const MySwal = withReactContent(Swal);

export const BuySeasonPassModal = ({
    membershipCard,
    ticketTemplate,
    event,
    onConfirmBuySeasonPass,
    onlyNfcPayment = false,
    availablePoints,
    title,
}) => {
    const txt = getCurrentLanguageTexts();
    const [seatLabel, setSeatLabel] = useState(getSeatLabel(membershipCard));
    const [cardSelected, setCardSelected] = useState(onlyNfcPayment);
    const [companyVatNumber, setCompanyVatNumber] = useState("");
    const [companyCountry, setCompanyCountry] = useState(
        txt.BuySeasonPassModalTxt.companyCountryOptions[0].value
    );
    const [isTermsChecked, setTermsChecked] = useState(false);
    const [isDiscountApplied, setIsDiscountApplied] = useState(false);
    const [isShowTerms, setIsShowTerms] = useState(false);

    const nfcCardTicket = event.ticketTemplates.find(t => t.ticketTemplateId == process.env.REACT_APP_NEW_SEASON_NFC_CARD_TICKET_TEMPLATE_ID);
    const tickets = [];

    if (!isDiscountApplied) {
        ticketTemplate.price -= membershipCard.holdedDiscount;
        setIsDiscountApplied(true);
    }

    if (!onlyNfcPayment) {
        tickets.push(MembershipToSeasonPassTicket(membershipCard, ticketTemplate))
    }

    if (cardSelected) {
        if (nfcCardTicket) {
            tickets.push(NfcToTicket(membershipCard, nfcCardTicket));
        }
    }

    let totalPrice = getPrice(tickets, event.ticketTemplates, null, 0);

    let pointsToDiscount = (totalPrice * 0.7).toFixed(0);

    if (pointsToDiscount > availablePoints) {
        pointsToDiscount = availablePoints;
    }


    const totalFee = getTotalFee(tickets, event.fixedFeeRate, event.feeRate, event.ticketTemplates, null, pointsToDiscount);

    totalPrice = getPrice(tickets, event.ticketTemplates, null, pointsToDiscount) + totalFee;

    const confirmHandler = () => {
        const seats = [{
            ticketName: ticketTemplate.name,
            area: membershipCard.area,
            side: membershipCard.side,
            row: membershipCard.row,
            seat: membershipCard.seat,
            ticketTemplateId: ticketTemplate.ticketTemplateId,
            amount: (ticketTemplate.price * (1 + event.feeRate)).toFixed(2),
            optionalParameters: JSON.stringify({
                membershipId: membershipCard.id
            })
        }];

        if (onlyNfcPayment) {
            seats.pop();
        }

        if (cardSelected) {
            seats.push(
                {
                    ticketName: nfcCardTicket.name,
                    ticketTemplateId: nfcCardTicket.ticketTemplateId,
                    area: membershipCard.area,
                    side: membershipCard.side,
                    row: membershipCard.row,
                    seat: membershipCard.seat,
                    amount: (nfcCardTicket.price * (1 + event.feeRate)).toFixed(2),
                })
        }

        MySwal.close();
        onConfirmBuySeasonPass(seats, membershipCard.customerName, totalPrice, pointsToDiscount, { companyVatNumber: companyVatNumber, companyCountry: companyCountry });
    };

    const handleOnBuyNfcChange = () => {
        if (!onlyNfcPayment) {
            setCardSelected(!cardSelected);
        }
    }

    const changeInputCompanyVatHandler = (e) => {
        setCompanyVatNumber(e.target.value);
    }

    const changeCompanyCountryHandler = (e) => {
        setCompanyCountry(e.value);
    }

    const showTermsAndConditionsModal = (ev) => {
        ev.preventDefault();
        setIsShowTerms(true);
    };

    const handleTermsChangeCheckbox = () => {
        setTermsChecked(!isTermsChecked);
    }

    return <>
        <section className="buy-sp-modal">

            <div style={{ display: isShowTerms ? 'none' : 'block' }}>
                <h2 className="first-title">{title}</h2>
                <p><strong>{seatLabel}</strong></p>
                <p>{txt.BuySeasonPassModalTxt['NFCDescription']}</p>
                {!onlyNfcPayment
                    &&
                    <CheckBox
                        name="buyNfcCard"
                        id="buy-nfc-card"
                        checked={cardSelected}
                        onChange={handleOnBuyNfcChange}>
                        {txt.BuySeasonPassModalTxt['buyPhysicalNFCCard']}
                    </CheckBox>
                }
                <section style={{ marginBottom: "20px" }}>
                    <SelectedTickets
                        hasSeats={true}
                        mixedTickets={true}
                        totalFee={totalFee}
                        tickets={tickets}
                        currency={'RSD'}
                        total={totalPrice}
                        allowEnterCouponCode={false}
                        autoHeight={true}
                        pointsForDiscount={pointsToDiscount}
                        isTermsChecked={isTermsChecked}
                        handleChangeCheckbox={handleTermsChangeCheckbox}
                        showTermsAndConditionsModal={showTermsAndConditionsModal}
                    />
                    <input
                        type="text"
                        name="companyVatNumber"
                        className="buy-sp-modal__vat-number"
                        placeholder={txt.BuySeasonPassModalTxt['vatPlaceholder']}
                        value={companyVatNumber}
                        onChange={changeInputCompanyVatHandler}
                    />
                    <Select
                        options={txt.BuySeasonPassModalTxt.companyCountryOptions}
                        name="companyCountry"
                        value={txt.BuySeasonPassModalTxt.companyCountryOptions.find(
                            ({ value }) => companyCountry === value
                        )}
                        onChange={changeCompanyCountryHandler}
                        classNamePrefix="seasonpass__select partizan-open-selling__select"
                        className="seasonpass__select partizan-open-selling__select buy-sp-modal__select"
                    />
                </section>
            </div>

            <div style={{ display: isShowTerms ? 'block' : 'none' }}>
                <TermsAndConditionsModal />
            </div>

            <section className='swal2-actions'>
                {!isShowTerms ?
                    <>
                        <button className="swal2-cancel swal2-styled"
                            onClick={() => MySwal.close()} >
                            {txt.generalTxt['cancel']}
                        </button>
                        <button
                            className="swal2-confirm swal2-styled btn-primary"
                            onClick={confirmHandler}
                            disabled={!isTermsChecked}
                        >
                            {txt.generalTxt['confirm']}
                        </button>
                    </> : <button
                        type='button'
                        className='swal2-cancel swal2-styled'
                        onClick={() => setIsShowTerms(false)}
                    >
                        Ok
                    </button>
                }

            </section>

        </section>
    </>
}